module.exports = __webpack_public_path__ + "90c795264a7e26a0498c8f31bb5b15c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-6.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-6.jpg
// module chunks = 40